import { IRole, IRoleConfig } from '../../_shared/models/models-index';
import { RolePermissions } from '../../_shared/models/security';

export class RoleConfig implements IRoleConfig {
  systemAdministratorRoles: IRole[] = [
    { roleId: 1, name: 'System Administrator', permissions: [RolePermissions.ViewManagement, RolePermissions.DataSetContributor, RolePermissions.ReportViewContributor, RolePermissions.QueryContributor] },
    { roleId: 9, name: "System Analyst", permissions: [RolePermissions.ViewManagement] }
  ];
  corporateRoles: IRole[] = [
    { roleId: 2, name: 'Corporate' }
  ];
  org4Roles: IRole[] = [];
  org5Roles: IRole[] = [];
  org3Roles: IRole[] = [
    { roleId: 3, name: 'Region Manager' }
  ];
  org2Roles: IRole[] = [
    { roleId: 4, name: 'Area Manager' }
  ];
  org1Roles: IRole[] = [
    { roleId: 5, name: 'District Manager' }
  ];
  dealerRoles: IRole[] = [
    { roleId: 6, name: 'Dealer' }
  ];
  dealerGroupRoles: IRole[] = [];
  agencyRoles: IRole[] = [
    { roleId: 8, name: 'Agency', defaultRoute: 'digAd/tier2-dashboard' }
  ]
}
